import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=1b7ef77a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7ef77a')) {
      api.createRecord('1b7ef77a', component.options)
    } else {
      api.reload('1b7ef77a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=1b7ef77a&", function () {
      api.rerender('1b7ef77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22jpR9RB988h9/JS/comp/IncreaseNumber.vue"
export default component.exports